'use client'
import {
  Box,
  FocusLock,
  Icon,
  Input,
  InputGroup,
  InputLeftAddon,
} from '@core/ui-elements'
import { eitherOrString } from '@utils/utilities'
import { forwardRef, useImperativeHandle, useState } from 'react'
import { MdQrCodeScanner } from 'react-icons/md'

import { HiddenBarcodeInput } from '../hidden-barcode-input'
import {
  HiddenInputWithInputRef,
  IHiddenInputWithInput,
} from './hidden-input-with-input.types'

export const HiddenInputWithInput = forwardRef<
  HiddenInputWithInputRef,
  IHiddenInputWithInput
>(
  (
    {
      isLoading = false,
      submit,
      icon = MdQrCodeScanner,
      placeholder,
      returnValue,
    },
    ref
  ) => {
    const [setScannerDisable, setSetScannerDisable] = useState<boolean>(false)
    const [value, setValue] = useState<string | null>(null)

    const handleValue = (input: string | null) => {
      setValue(input)
      returnValue?.(input)
    }

    useImperativeHandle(ref, () => ({
      clearInput: () => handleValue(null),
    }))

    return (
      <Box>
        <HiddenBarcodeInput
          disabled={setScannerDisable || isLoading}
          handleSubmit={submit}
        />

        <FocusLock isDisabled={!setScannerDisable}>
          <InputGroup marginTop={'0.5rem'} padding={'0.0625rem'}>
            {icon && (
              <InputLeftAddon>
                <Icon as={icon} fontSize={'1rem'} />
              </InputLeftAddon>
            )}

            <Input
              borderLeftRadius={'0'}
              data-testid="scanProductID"
              inputMode="numeric"
              isDisabled={isLoading}
              placeholder={placeholder}
              value={eitherOrString(value)}
              onBlur={() => setSetScannerDisable(false)}
              onChange={(event) => handleValue(event.target.value)}
              onClickCapture={() => setSetScannerDisable(true)}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  event.preventDefault()
                  submit(value)
                  handleValue(null)
                  setSetScannerDisable(false)
                }
              }}
            />
          </InputGroup>
        </FocusLock>
      </Box>
    )
  }
)

HiddenInputWithInput.displayName = 'HiddenInputWithInput'
